import React from 'react';
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';

const StaffTimeOff: React.FC<RouteConfigComponentProps> = ({ route }) => renderRoutes(route?.routes);

export default StaffTimeOff;
